import React from "react";

/**
 * Vallitas Brand Logo — official PNG asset
 * Auto-swaps between vinotinto (light theme) and cream (dark theme / "light" variant).
 */
export default function Logo({
  className = "",
  variant = "dark", // "dark" -> vinotinto on light bg / "light" -> cream on dark bg
  showTagline = false,
  size = "md", // sm / md / lg
}) {
  const heights = { sm: 36, md: 56, lg: 88 };
  const h = heights[size] || 56;

  // For variant "dark" (default) we use the vinotinto PNG; on dark theme it stays vinotinto
  // because PNG colors don't change. To make it adapt to dark mode automatically we
  // render BOTH images and toggle visibility via the .dark class on <html>.
  const useLight = variant === "light";

  return (
    <span className={`inline-flex flex-col items-center leading-none ${className}`}>
      <span
        className="relative inline-block"
        style={{ height: `${h}px`, aspectRatio: "1530 / 608" }}
      >
        {useLight ? (
          <>
            {/* Light theme: vinotinto logo */}
            <img
              src="/brand/logo.png"
              className="h-full w-auto select-none hidden dark:block"
              alt="Vallitas"
              draggable={false}
            />
            {/* Dark theme: cream logo */}
            <img
              src="/brand/logo-light.png"
              alt="Vallitas"
              className="h-full w-auto select-none block dark:hidden"
              draggable={false}
              aria-hidden="true"
            />
          </>
        ) : (
          <>
            {/* Light theme: vinotinto logo */}
            <img
              src="/brand/logo.png"
              alt="Vallitas"
              className="h-full w-auto select-none block dark:hidden"
              draggable={false}
            />
            {/* Dark theme: cream logo */}
            <img
              src="/brand/logo-light.png"
              alt="Vallitas"
              className="h-full w-auto select-none hidden dark:block"
              draggable={false}
              aria-hidden="true"
            />
          </>
        )}
      </span>

      {showTagline && (
        <span
          className={`mt-3 text-[10px] sm:text-[11px] tracking-[0.32em] uppercase font-medium ${
            useLight ? "text-page" : "text-vino"
          }`}
        >
          Fé, Tradición y Amor
        </span>
      )}
    </span>
  );
}